import { ListingConfig } from "./index";

export const TransferConfig: ListingConfig = {
  reportConfig: {
    reportId: "voSKAA1lfVm9QybEKUis",
  },
  // Defines the primary date field in the 'capturedTransfer' collection for date range filtering
  dateField: "transactionDate", // Assuming 'transactionDate' is the correct field

  filterConfig: [
    {
      fieldIdToFilter: "documentNumber",
      label: "Document #",
      paramName: "documentNumber",
      placeholder: "e.g. T000-000-001",
      // No sourceCollection indicates this is a text input filter
    },
    {
      // Field in the 'capturedTransfer' collection to filter on
      fieldIdToFilter: "tankFromId", 
      label: "Dispensing Tank", // Label for the Select dropdown
      paramName: "tankFrom", // URL query parameter name
      sourceCollection: "tanks", // Firestore collection to fetch options from
      // sourceFieldForValue: "id", // Implicitly use document ID as the value
      sourceFieldForLabel: "name", // Field in 'tanks' documents for the dropdown label
                                  // Adjust "name" if your tanks collection uses a different field.
    },
    {
      // Field in the 'capturedTransfer' collection to filter on
      fieldIdToFilter: "mobileTankId", // Assuming this is the field name for the receiving tank ID
      label: "Receiving Tank", // Label for the Select dropdown
      paramName: "tankTo", // URL query parameter name (using "tankTo" for clarity)
      sourceCollection: "tanks", // Firestore collection to fetch options from
      // sourceFieldForValue: "id", // Implicitly use document ID as the value
      sourceFieldForLabel: "name", // Field in 'tanks' documents for the dropdown label
                                  // Adjust "name" if your tanks collection uses a different field.
    }
  ],
  fieldConfig: {
    tankFromId: {
      label: "Dispensing Tank",
      tableRank: -1,
      detailsRank: 3,
      editable: true,
      type: "SELECT",
      sourceCollection: "tanks",
      sourceFieldForLabel: "name",
      adjacentFields: {
        tankFromFuelType: "fuelType",
        tankFromIsMobile: "mobileTank",
        tankFromName: "name",
        tankFromSizeLiters: "size"
      }
    },
    mobileTankId: {
      label: "Receiving Tank",
      tableRank: -1,
      detailsRank: 6,
      editable: true,
      type: "SELECT",
      sourceCollection: "tanks",
      sourceFieldForLabel: "name",
      adjacentFields: {
        mobileTankIsMobile: "mobileTank",
        mobileTankName: "name",
        mobileTankSizeLiters: "size"
      }
    },
    deviceCaptured: {
      label: "Device capture date",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "DATE",
    },
    transactionDate: {
      label: "Date",
      tableRank: 0,
      detailsRank: 0,
      editable: true,
      type: "DATE",
    },
    transactionReviewed: {
      label: "Reviewed",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    },
    documentNumber: {
      label: "Document #",
      tableRank: 6,
      detailsRank: 100,
      editable: false,
      type: "STRING",
    },
    litres: {
      label: "Litres",
      tableRank: 5,
      detailsRank: 2,
      editable: true,
      type: "NUMBER",
    },
    tankFromName: {
      label: "Dispensing tank",
      tableRank: 2,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    tankFromIsMobile: {
      label: "Tank from is mobile",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    },
    mobileTankName: {
      label: "Receiving tank",
      tableRank: 3,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    mobileTankPhoto: {
      label: "Receiving tank photo",
      tableRank: -1,
      detailsRank: 7,
      editable: false,
      type: "IMAGE",
    },
    mobileTankIsMobile: {
      label: "Tank is mobile",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    },
    mobileTankSizeLiters: {
      label: "Receiving tank size",
      tableRank: -1,
      detailsRank: 9,
      editable: false,
      type: "NUMBER",
    },
    tankFromFuelType: {
      label: "Receiving tank fuel type",
      tableRank: 7,
      detailsRank: 10,
      editable: false,
      type: "STRING",
    },
    tankFromSizeLiters: {
      label: "Dispensing tank size",
      tableRank: -1,
      detailsRank: 11,
      editable: false,
      type: "NUMBER",
    },
    meterReadingStart: {
      label: "Meter reading start",
      tableRank: -1,
      detailsRank: 12,
      editable: true,
      type: "NUMBER",
    },
    meterReadingStartPhoto: {
      label: "Meter reading start photo",
      tableRank: -1,
      detailsRank: 13,
      editable: false,
      type: "IMAGE",
    },
    meterReadingEnd: {
      label: "Meter reading end",
      tableRank: 6,
      detailsRank: 14,
      editable: true,
      type: "NUMBER",
    },
    meterReadingEndPhoto: {
      label: "Meter reading end photo",
      tableRank: -1,
      detailsRank: 15,
      editable: false,
      type: "IMAGE",
    },
    pumpAttendantSignedImage: {
      label: "Pump attendant signature",
      tableRank: -1,
      detailsRank: 17,
      editable: false,
      type: "IMAGE",
    },
    fuelReceiverSign: {
      label: "Receiver",
      tableRank: -1,
      detailsRank: 18,
      editable: false,
      type: "STRING",
    },
    fuelReceiverSignedImage: {
      label: "Receiver signature",
      tableRank: -1,
      detailsRank: 19,
      editable: false,
      type: "IMAGE",
    },
    createdBy: {
      label: "Creator",
      tableRank: -1,
      detailsRank: 20,
      editable: false,
      type: "STRING",
    },
    gpsLocation: {
      label: "Location",
      tableRank: -1,
      detailsRank: 21,
      editable: false,
      type: "COORDINATE",
    },
    isModified: {
      label: "Data modified",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    },
    companyId: {
      label: "Company ID",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    id: {
      label: "ID",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    syncCompleted: {
      label: "--INTERNAL--",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    },
    receivedOnServer: {
      label: "--INTERNAL--",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "DATE",
    },
  },
};
